import { z } from "zod";

/**
 * Wire shape of `user.artistSubscriptions.listItems`. Co-located with the
 * procedure so the client durable-cache layer
 * (`apps/mobile/hooks/trpc/useFollow/queryFunctions.ts`) can parse cached
 * rows on read. A drift assertion in that file binds the schema to the
 * tRPC return type at compile time.
 */
export const followingItemSchema = z.object({
  userId: z.string(),
  artistId: z.string(),
  type: z.enum(["follow", "subscribe"]),
});

export const followingsListSchema = z.array(followingItemSchema);

export type FollowingItem = z.infer<typeof followingItemSchema>;
export type FollowingsList = z.infer<typeof followingsListSchema>;
